import React from 'react';

import { 
  Box, 
  Divider, 
  Typography 
} from '@mui/material';

import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import DynamicFeedOutlinedIcon from '@mui/icons-material/DynamicFeedOutlined';
import DomainVerificationOutlinedIcon from '@mui/icons-material/DomainVerificationOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import DataArrayIcon from '@mui/icons-material/DataArray';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BusinessIcon from '@mui/icons-material/Business';
import PublicIcon from '@mui/icons-material/Public';

import "./styles.scss";

const WatchTowerNavigation = ({
  path,
  currentPage, 
  navigate
}) => {
  return (
    path.length > 2 && 
    path[2] === "environment"
    ?
    <Box className="nav__side-common" 
      display={"flex"} flexDirection={"column"} gap={"10px"}>
      <Box className="nav__side-container">
        <Box className={`nav__side-item flexCenter_Row`}
          onClick={() => {
            navigate("/watch");
          }}>
          <ArrowBackIcon />
          <Typography variant='body2'>
            Back
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/watch/environment");
          }}>
          <HomeOutlinedIcon />
          <Typography variant='body2'>
            Home Page
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 1 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/watch/environment/consumer");
          }}>
          <StorefrontIcon />
          <Typography variant='body2'>
            Consumer (B2C)
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 2 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/watch/environment/business");
          }}>
          <BusinessIcon />
          <Typography variant='body2'>
            Business (B2B)
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 3 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/watch/environment/sdk");
          }}>
          <DataArrayIcon />
          <Typography variant='body2'>
            SDK
          </Typography>
        </Box>
        <Box className={`${currentPage === 4 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/watch/environment/support");
          }}>
          <SupportAgentOutlinedIcon />
          <Typography variant='body2'>
            Support
          </Typography>
        </Box>
      </Box>


    </Box>
      :
        <Box className="nav__side-common flex_SBColumn" 
          display={"flex"} flexDirection={"column"} gap={"10px"}>
          <Box className="nav__side-container">
            <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
              onClick={() => {
                navigate("/watch");
              }}>
              <HomeOutlinedIcon />
              <Typography variant='body2'>
                Home Page - WatchTower
              </Typography>
            </Box>
            <Box className={`${currentPage === 1 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
              onClick={() => {
                navigate("/watch/contact-requests");
              }}>
              <BackHandOutlinedIcon />
              <Typography variant='body2'>
                Contact Requests
              </Typography>
            </Box>
            <Box className={`${currentPage === 2 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
              onClick={() => {
                navigate("/watch/demo-certify-domains");
              }}>
              <DomainVerificationOutlinedIcon />
              <Typography variant='body2'>
                Demo Access Domains
              </Typography>
            </Box>
            <Box className={`${currentPage === 3 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
              onClick={() => {
                navigate("/watch/demo-approvals");
              }}>
              <RuleOutlinedIcon />
              <Typography variant='body2'>
                Demo Access Approvals
              </Typography>
            </Box>
            <Box className={`${currentPage === 4 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
              onClick={() => {
                navigate("/watch/demo-analytics");
              }}>
              <InsightsOutlinedIcon />
              <Typography variant='body2'>
                Demo Access Analytics
              </Typography>
            </Box>
            <Box className={`${currentPage === 5 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
              onClick={() => {
                navigate("/watch/app-versions");
              }}>
              <DynamicFeedOutlinedIcon />
              <Typography variant='body2'>
                App Versions
              </Typography>
            </Box>
          </Box>

          <Box display={"flex"}
            flexDirection={"column"}
            gap={"10px"}>
            <Box className="nav__side-container">
              <Box className={`nav__side-item flexCenter_Row`}
                onClick={() => navigate("/watch/environment")}>
                <PublicIcon />
                <Typography variant='body2'>
                  Environments
                </Typography>
              </Box>
            </Box>
          </Box>  
        </Box>
  )
}

export default WatchTowerNavigation;